module.exports = __webpack_public_path__ + "img/Inside-sp_7.47a04892.jpg";